import { Component, ViewChild } from '@angular/core';
import { TableName } from '@/common/enums/TableName';
import { GeneralTasksFilterComponent } from './general-tasks-filter/general-tasks-filter.component';

@Component({
	selector: 'app-general-tasks-list',
	templateUrl: './general-tasks-list.component.html',
	styleUrls: ['./general-tasks-list.component.scss'],
})
export class GeneralTasksListComponent {
	@ViewChild(GeneralTasksFilterComponent)
	filterComponent!: GeneralTasksFilterComponent;

	protected setFilters() {
		this.filterComponent.setFilters();
	}

	protected readonly TableName = TableName;
}
